<template>
  <div
    class="lg:px-7.5 flex h-8 items-center justify-between px-2 pt-1.5 md:px-4"
  >
    <div
      v-if="catalogSettings"
      class="flex w-full flex-col-reverse items-start md:flex-row md:items-center"
    >
      <div
        v-if="isTokenLoaded && !hideNav"
        class="mr-1 hidden items-center space-x-0.5 rtl:ml-1 rtl:flex-row-reverse md:flex"
      >
        <a
          href="#"
          class="text-primary hover:text-primary-active"
          @click.prevent="$router.go(-1)"
        >
          <lucide-icon icon="ChevronLeft" size="16" />
        </a>

        <router-link
          v-hint="{
            position: 'bottom-center',
            yOffset: 8,
            text: $t('routes.Main'),
            showDelay: 600,
          }"
          :to="mainPageConfig"
          class="text-primary hover:text-primary-active"
        >
          <lucide-icon icon="HomeIcon" size="16" />
        </router-link>
        <a
          href="#"
          class="text-primary hover:text-primary-active"
          @click.prevent="$router.go(1)"
        >
          <lucide-icon icon="ChevronRight" size="16" />
        </a>
      </div>

      <LanguageSelect
        v-if="!$windowSize.isMobile && !hideLang"
        button-class="transition-colors w-37.5 mr-1 rtl:ml-1 bg-gray-100 dark:bg-neutral-800 py-0.5 px-1.5 text-sm leading-3 h-6 rounded hover:bg-gray-200 dark:hover:bg-neutral-700 cursor-pointer"
        class="me-2"
      ></LanguageSelect>
      <div
        v-if="catalogs.show_selector && isTokenLoaded && !hideCatalogSelect"
        v-hint="{
          enabled: isTokenLoaded,
          position: 'bottom-center',
          yOffset: 8,
          text: $t('routes.Projects'),
          showDelay: 600,
        }"
        class="hover:text-primary flex max-w-full cursor-pointer items-center gap-1 text-sm md:mt-0.5 md:pr-1 md:text-base rtl:md:pl-1"
        @click.prevent="
          OPEN_MODAL({
            type: 'catalogSelect',
          })
        "
      >
        <span class="md:max-w-130 max-w-full truncate"
          >{{ catalogSettings.name }}
        </span>
        <lucide-icon class="mb-0.5 shrink-0" icon="ChevronDown" size="16" />
      </div>
      <div
        v-else-if="isTokenLoaded"
        class="w-full truncate text-sm md:mt-0.5 md:pr-1 md:text-base rtl:md:pl-1"
      >
        {{ catalogSettings.name }}
      </div>
    </div>
    <div
      v-if="catalogSettings && !hideTheme"
      class="flex items-center justify-end"
    >
      <ThemeSelect v-if="!$windowSize.isMobile && isTokenLoaded"></ThemeSelect>

      <!-- <a
          v-if="!$windowSize.isMobile"
          href="#"
          class="ml-4 rtl:mr-4 hidden md:inline text-sm line-clamp-1"
          >{{ $t('control.How to use') }}</a
        > -->

      <button
        v-if="
          !hideClose &&
          ((inCrmApplication && crm.type != 'Bitrix24') || openedFromUrl)
        "
        class="ml-4 flex cursor-pointer items-center text-red-500 hover:text-red-600 rtl:mr-4"
        @click="closeIframe"
      >
        <lucide-icon icon="X" size="16" />
        <div
          v-if="!$windowSize.isMobile"
          class="ml-0.5 mt-0.5 text-xs rtl:mr-0.5"
        >
          {{ $t('control.Close') }}
        </div>
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import LanguageSelect from './LanguageSelect.vue';
import ThemeSelect from './ThemeSelect.vue';
import Hint from '@/libs/directives/Hint';

export default {
  name: 'HeaderTop',
  components: {
    LanguageSelect,
    ThemeSelect,
  },
  directives: {
    Hint,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      'openedFromUrl',
      'catalogSettings',
      'catalogs',
      'interactiveSettings',
      'isTokenLoaded',
      'inCrmApplication',
      'crm',
      'hideNav',
      'hideLang',
      'hideTheme',
      'hideCatalogSelect',
      'hideClose',
    ]),
    mainPageConfig() {
      if (this.catalogSettings.main_page == 'Interactive') {
        return this.getRouterConfig({
          name: 'Interactive',
          params: {
            frameId: this.interactiveSettings.default_frame_id,
            interactiveId: this.interactiveSettings.default_id,
          },
        });
      }
      return this.getRouterConfig({ name: this.catalogSettings.main_page });
    },
  },

  methods: {
    ...mapActions(['OPEN_MODAL']),

    closeIframe() {
      if (window.location !== window.parent.location) {
        window.parent.postMessage(
          {
            type: 'closeRPTModule',
          },
          '*'
        );
        console.log('openedFromUrl', this.openedFromUrl);
        if (this.openedFromUrl) {
          window.parent.postMessage(
            {
              type: 'closeRPTModule',
            },
            this.openedFromUrl
          );
        }
      } else if (this.openedFromUrl) {
        window.location.href = this.openedFromUrl;
      }
    },
  },
};
</script>
